export const MOVEMENT_OPTIONS = [
  { slug: 'push', label: 'Empurrar' },
  { slug: 'pull', label: 'Puxar' },
  { slug: 'squat', label: 'Agachar' },
  { slug: 'hinge', label: 'Hinge / posterior' },
  { slug: 'carry', label: 'Carregar' },
  { slug: 'rotation', label: 'Rotação' },
  { slug: 'core', label: 'Core' },
];

export const EQUIPMENT_OPTIONS = [
  { slug: 'barbell', label: 'Barra' },
  { slug: 'dumbbell', label: 'Halteres' },
  { slug: 'machine', label: 'Máquinas' },
  { slug: 'cable', label: 'Polia / cabo' },
  { slug: 'bodyweight', label: 'Peso corporal' },
  { slug: 'kettlebell', label: 'Kettlebell' },
  { slug: 'resistance_band', label: 'Elásticos' },
];

export const LIMITATION_OPTIONS = [
  { slug: 'knee', label: 'Joelho' },
  { slug: 'lower_back', label: 'Lombar' },
  { slug: 'shoulder', label: 'Ombro' },
  { slug: 'wrist', label: 'Punho' },
  { slug: 'hip', label: 'Quadril' },
  { slug: 'neck', label: 'Pescoço' },
  { slug: 'none', label: 'Nenhuma' },
];

export const PRIOR_STYLE_OPTIONS = [
  { slug: 'powerlifting', label: 'Powerlifting' },
  { slug: 'bodybuilding', label: 'Bodybuilding' },
  { slug: 'crossfit', label: 'CrossFit' },
  { slug: 'calisthenics', label: 'Calistenia' },
  { slug: 'cardio', label: 'Cardio' },
];

export const RESPONSE_PROFILE_OPTIONS = [
  { slug: 'fast_recovery', label: 'Recuperação rápida' },
  { slug: 'slow_recovery', label: 'Recuperação lenta' },
  { slug: 'volume_responder', label: 'Responde a volume' },
  { slug: 'intensity_responder', label: 'Responde a intensidade' },
];

export const EMPTY_TRAINING_PROFILE = {
  movementPreferences: [],
  equipmentContext: [],
  limitations: [],
  trainingHistory: { monthsConsistent: null, priorStyles: [] },
  schedulePattern: { daysPerWeek: null, minutesPerSession: null },
  responseProfile: null,
};

export function parseTrainingProfile(raw) {
  if (!raw) return { ...EMPTY_TRAINING_PROFILE };
  if (typeof raw === 'object' && !Array.isArray(raw)) {
    return {
      ...EMPTY_TRAINING_PROFILE,
      ...raw,
      movementPreferences: Array.isArray(raw.movementPreferences) ? raw.movementPreferences : [],
      equipmentContext: Array.isArray(raw.equipmentContext) ? raw.equipmentContext : [],
      limitations: Array.isArray(raw.limitations) ? raw.limitations : [],
      trainingHistory: {
        ...EMPTY_TRAINING_PROFILE.trainingHistory,
        ...(raw.trainingHistory || {}),
        priorStyles: Array.isArray(raw.trainingHistory?.priorStyles)
          ? raw.trainingHistory.priorStyles
          : [],
      },
      schedulePattern: {
        ...EMPTY_TRAINING_PROFILE.schedulePattern,
        ...(raw.schedulePattern || {}),
      },
    };
  }
  if (typeof raw === 'string' && raw.trim().startsWith('{')) {
    try {
      return parseTrainingProfile(JSON.parse(raw));
    } catch {
      return { ...EMPTY_TRAINING_PROFILE };
    }
  }
  return { ...EMPTY_TRAINING_PROFILE };
}

export function isFingerprintComplete(trainingProfile) {
  const tp = parseTrainingProfile(trainingProfile);
  return tp.movementPreferences.length >= 1 && tp.equipmentContext.length >= 1;
}
